export const ORG_SLUG_COOKIE = 'organization-slug'
export const ORG_SLUG_HEADER = 'X-Organization-Slug'
